import { getProvidersData } from '../../../helpers/data-helper';

import Step1 from '../Step1/Step1';
import Step2 from '../Step2/Step2';
import Step3 from '../Step3/Step3';
import Step4 from '../Step4/Step4';
import Step5 from '../Step5/Step5';

export default {
	props: ['inverted', 'provider', 'index'],
	data: function() {
		return {
			current_step: 0,
			prev_step: 0,
			provider_data: {},
			rank: this.index,
			slide: 0
		}
	},
	components: {
		'review-step1': Step1,
		'review-step2': Step2,
		'review-step3': Step3,
		'review-step4': Step4,
		'review-step5': Step5
	},
	mounted: function() {
		this.trackCardScrolling();
		let data = getProvidersData();
		this.provider_data = data[this.provider];
	},
	methods: {
		change_step: function(step) {
			let vm = this;
			vm.current_step = step;
			// vm.$set(vm.current_step, index, step);

			setTimeout(function() {
				let carousel = document.getElementById("carousel_"+vm.provider_data.slug);
				if ( carousel) {
					let ele = carousel.getElementsByClassName("carousel-item")[vm.current_step];
					if (ele) {
						carousel.style.height = ele.clientHeight+"px";
					}
				}
			}, 250);
		},
		disableBodyScroll: function() {
			var ele = document.getElementsByTagName('body')[0];
			ele.style.overflow = "hidden";
			ele.style.paddingRight = "16px";
		},
		enableBodyScroll: function() {
			var ele = document.getElementsByTagName('body')[0];
			ele.style.overflow = "";
			ele.style.paddingRight = "";
		},
		trackCardScrolling: function() {
			let vm = this;

			this.$refs.card.onmouseover = function() {
				vm.disableBodyScroll();
			}

			this.$refs.card.onmouseleave = function() {
				vm.enableBodyScroll();
			}

			let scroll = true;
			this.$refs.card.onwheel = function(e) {
				if (scroll) {
					if (e.deltaY > 0) {
						if(vm.current_step < 4) {
							vm.change_step(++vm.current_step);
							var ele = document.getElementsByClassName('step1')[0];
						} else {
							vm.enableBodyScroll();
						}
					}

					if (e.deltaY < 0) {
						if (vm.current_step > 0) {
							vm.change_step(--vm.current_step);
						} else {
							vm.enableBodyScroll();
						}
					}
					let timeout = setTimeout(function() {
						scroll = true;
					}, 1000);
				}
				scroll = false;
			}
		},

		nextStep: function() {
			if (this.current_step < 4) {
				this.change_step(this.current_step+1) ;
			}
		},
		previousStep: function() {
			if (this.current_step > 0) {
				this.change_step(this.current_step-1) ;
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/Reviews/Review-Card/review-card.js